<template>
  <div class="home-container">
    <headerNav v-if="!isFromPlugin"></headerNav>
    <sideBar></sideBar>
    <!--<navTab></navTab>-->
    <contentMain :class="isFromPlugin ? 'noPadding-top' : ''"></contentMain>
  </div>
</template>

<script>
  import homeJs from './home.js'

  export default homeJs

</script>

<style scoped lang="scss">
.noPadding-top{
  padding-top: 1px !important;
}
</style>



// WEBPACK FOOTER //
// src/layout/home/home.vue